/**
 * What an address in a text card shows as. The same rules as the server's
 * (backend/services/dashboards/media.js): an image by its extension, a video
 * or document from a known host in that host's own player, anything else a
 * link. Only the address is stored; the frame's source is always built here.
 */
const MAX_URL = 2000;
const IMAGE = /\.(png|jpe?g|gif|webp|avif|svg)(\?[^#]*)?(#.*)?$/i;

function parse(raw) {
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s || s.length > MAX_URL) return null;
  let u;
  try { u = new URL(s); } catch (_) { return null; }
  if (u.protocol !== 'https:' || u.username || u.password) return null;
  return u;
}

/** { kind: 'image'|'video'|'embed'|'link', provider, src } or null. */
export function classifyMedia(raw) {
  const u = parse(raw);
  if (!u) return null;
  const h = u.hostname.replace(/^www\./, '').toLowerCase();
  const path = u.pathname;
  const id = (re) => (re.exec(path) || [])[1] || null;
  if (h === 'youtube.com' || h === 'm.youtube.com' || h === 'youtu.be') {
    const v = h === 'youtu.be' ? id(/^\/([\w-]{6,20})/) : (u.searchParams.get('v') || id(/^\/(?:shorts|embed|live)\/([\w-]{6,20})/));
    if (v && /^[\w-]{6,20}$/.test(v)) return { kind: 'video', provider: 'YouTube', src: `https://www.youtube-nocookie.com/embed/${v}` };
  }
  if (h === 'vimeo.com' || h === 'player.vimeo.com') {
    const v = id(/\/(\d{5,12})(?:\/|$)/);
    if (v) return { kind: 'video', provider: 'Vimeo', src: `https://player.vimeo.com/video/${v}` };
  }
  if (h === 'loom.com') {
    const v = id(/^\/(?:share|embed)\/([0-9a-f]{20,40})/i);
    if (v) return { kind: 'video', provider: 'Loom', src: `https://www.loom.com/embed/${v}` };
  }
  if (h === 'figma.com' && /^\/(file|design|proto|board)\//.test(path)) {
    return { kind: 'embed', provider: 'Figma', src: `https://www.figma.com/embed?embed_host=trodo&url=${encodeURIComponent(u.href)}` };
  }
  if (h === 'docs.google.com' && /^\/(document|spreadsheets|presentation)\/d\/[\w-]+/.test(path)) {
    const base = /^(\/(?:document|spreadsheets|presentation)\/d\/[\w-]+)/.exec(path)[1];
    return { kind: 'embed', provider: 'Google', src: `https://docs.google.com${base}/preview` };
  }
  if (IMAGE.test(path)) return { kind: 'image', provider: h, src: u.href };
  return { kind: 'link', provider: h, src: u.href };
}
